// Input.js
import React, { forwardRef } from "react";

const Input = forwardRef(function InputComponent(props, ref) {
  const classes =
    "input px-3 input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline " +
    props.className;

  const handleKeyDown = (e) => {
    if (props.type === "number" && ["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <input
      ref={ref}
      className={classes}
      placeholder={props.placeholder || " "}
      onChange={(e) => props?.inputchangehandler?.(e?.target?.value)}
      value={props?.value}
      name={props?.name}
      checked={props?.checked}
      readOnly={props?.readOnly}
      disabled={props?.disabled}
      onBlur={props?.onBlur}
      maxLength={props?.maxLength}
      type={props?.type}
      onKeyDown={handleKeyDown}
    />
  );
});

export default Input;
